import { forwardRef } from 'react'
import { useSelector } from 'react-redux'
import { CheckBoxOutlineBlank, Delete, DragHandle, ExpandMore } from '@mui/icons-material'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import { Box } from '@mui/system'
import PropTypes from 'prop-types'

import { selectCollapsedItems } from '@/app/slices/quoteItemsSlice'

import QuoteItemStatus from '../common/QuoteItemStatus'

const classes = {
    Overlay: {
        borderRadius: 2,
        overflow: 'hidden',
        backgroundColor: 'primary.main',

        boxShadow: 15,
        zIndex: 10,
    },

    OverlayContent: {
        px: 2,
        py: 1.5,
        display: 'flex',
        justifyContent: 'space-between',
        height: 74,
    },

    OverlayContentLeft: {
        gap: 1.5,
    },

    OverlayContentRight: {
        gap: 6,
    },

    OverlayContentColor: {
        color: 'primary.contrastText',
    },
    OverlayDetailsContent: {
        height: 436,
        backgroundColor: 'primary.light',
    },
}

const QuoteItemOverlay = forwardRef(({ id, name, ...props }, ref) => {
    const collapsedItemsArray = useSelector(selectCollapsedItems)

    const isCollapsed = collapsedItemsArray.includes(id)

    return (
        <Box
            sx={classes.Overlay}
            {...props}
            ref={ref}
        >
            <Box sx={classes.OverlayContent}>
                <Box
                    alignItems="center"
                    display="flex"
                    sx={classes.OverlayContentLeft}
                >
                    <IconButton
                        size="small"
                        sx={classes.OverlayContentColor}
                    >
                        <DragHandle />
                    </IconButton>

                    <CheckBoxOutlineBlank
                        fontSize="small"
                        sx={classes.OverlayContentColor}
                    />

                    <Box
                        alignItems="center"
                        display="flex"
                        gap={2}
                    >
                        <QuoteItemStatus status="overlay" />

                        <Typography sx={classes.OverlayContentColor}>{name}</Typography>
                    </Box>
                </Box>

                <Box
                    alignItems="center"
                    display="flex"
                    sx={classes.OverlayContentRight}
                >
                    <Box
                        alignItems="center"
                        display="flex"
                    >
                        <IconButton sx={classes.OverlayContentColor}>
                            <Delete />
                        </IconButton>

                        <ExpandMore sx={classes.OverlayContentColor} />
                    </Box>
                </Box>
            </Box>
            {!isCollapsed ? <Box sx={classes.OverlayDetailsContent}></Box> : null}
        </Box>
    )
})

QuoteItemOverlay.displayName = 'QuoteItemOverlay'

QuoteItemOverlay.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
}

export default QuoteItemOverlay
